export const formatCurrency = (currencyValue) => {
    if (typeof currencyValue !== 'number')
        return currencyValue;
    return new Intl.NumberFormat().format(currencyValue);
};
